var _path, _path2, _path3, _path4;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrashEmpty = function SvgTrashEmpty(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 93,
    viewBox: "0 0 81 93",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1503 29.4529H68.8503L65.2337 82.0577C64.9943 85.5394 62.0832 88.362 58.7433 88.362H22.2572C18.9121 88.362 16.0077 85.5603 15.7668 82.0577L12.1503 29.4529Z",
    stroke: "#DDE2E4",
    strokeWidth: 6.94286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6252 46.2856L48.6002 71.5324",
    stroke: "#DDE2E4",
    strokeWidth: 6.94286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3752 46.2856L32.4002 71.5324",
    stroke: "#DDE2E4",
    strokeWidth: 6.94286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1401 12.6237C6.77477 12.6237 4.05005 15.4498 4.05005 18.936V23.1424C4.05005 26.6174 6.77665 29.4548 10.1401 29.4548H70.86C74.2253 29.4548 76.9501 26.6287 76.9501 23.1424V18.936C76.9501 15.4611 74.2235 12.6237 70.86 12.6237L54.6751 10.5205C54.6751 7.04548 51.9521 4.20807 48.5933 4.20807H32.4068C29.0434 4.20807 26.325 7.03422 26.325 10.5205L10.1401 12.6237Z",
    stroke: "#DDE2E4",
    strokeWidth: 6.94286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrashEmpty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash-empty.759fa7b0.svg";
export { ForwardRef as ReactComponent };